export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9663.b01573b6.jpg";